import addZero from 'add-zero';
import round from 'lodash.round';

/**
 * Converts a number of milliseconds to an object of bigger units of time.
 * @param {number} ms
 * @returns {{
 * days: number,
 * hours: number,
 * minutes: number,
 * seconds: number,
 * milliseconds: number
 * }} time
 */
export const parseMs = (ms) => {
  if (typeof ms !== 'number') {
    throw new TypeError('Expected a number');
  }

  const roundTowardZero = ms > 0 ? Math.floor : Math.ceil;

  return {
    days: roundTowardZero(ms / 86400000),
    hours: roundTowardZero(ms / 3600000) % 24,
    minutes: roundTowardZero(ms / 60000) % 60,
    seconds: roundTowardZero(ms / 1000) % 60,
    milliseconds: roundTowardZero(ms) % 1000,
  };
};

/**
 * Converts a number of milliseconds to a string of bigger units of time.
 * @param {number} ms
 * @returns {string} minutes:seconds.milliseconds
 */
export const formatDuration = (ms) => {
  const { minutes, seconds, milliseconds } = parseMs(ms);

  // it coverts 4 ms => 004 => 00,4 => 00
  // 138 => 13,8 => 14
  const formattedMiliseconds = round(addZero(milliseconds, 3) / 10);

  return `${addZero(minutes)}:${addZero(seconds)}.${addZero(formattedMiliseconds)}`;
};
